export const LOGIN_SUBSCRIPTION_STATUS_CHECK_START = 'LOGIN_SUBSCRIPTION_STATUS_CHECK_START';
export const LOGIN_SUBSCRIPTION_STATUS_CHECK_SUCCESS = 'LOGIN_SUBSCRIPTION_STATUS_CHECK_SUCCESS';
export const LOGIN_SUBSCRIPTION_STATUS_CHECK_FAIL = 'LOGIN_SUBSCRIPTION_STATUS_CHECK_FAIL';
export const LOGIN_SUBSCRIPTION_STATUS_CHECK_RESET = 'LOGIN_SUBSCRIPTION_STATUS_CHECK_RESET';
